import React from "react";
import { Link } from "react-router-dom";
import JsonLd from "../JsonLd";
import { Container } from "./styles";

/**
 * Breadcrumb reutilizável (trilha de navegação + JSON-LD BreadcrumbList).
 *
 * Props:
 *   items   {Array<{ name: string, to?: string }>} — itens da trilha. O último
 *           é o item atual (renderizado em negrito, sem link). Itens com `to`
 *           viram links; sem `to`, viram apenas texto.
 *   withHome {boolean} — prepend automático de "Início" (to "/"). Default: true.
 *   jsonLd   {boolean} — emite <JsonLd type="BreadcrumbList" />. Default: true.
 */
export default function Breadcrumb({ items = [], withHome = true, jsonLd = true }) {
  const trail = withHome ? [{ name: "Início", to: "/" }, ...items] : items;

  const validTrail = trail.filter((item) => item && item.name);
  if (validTrail.length === 0) return null;

  const lastIndex = validTrail.length - 1;

  const jsonLdData = {
    items: validTrail.map((item) => ({
      name: item.name,
      url: item.to ? `${window.location.origin}${item.to}` : window.location.href,
    })),
  };

  return (
    <>
      {jsonLd && <JsonLd type="BreadcrumbList" data={jsonLdData} />}
      <Container aria-label="breadcrumb">
        <ol>
          {validTrail.map((item, index) => {
            const isLast = index === lastIndex;
            return (
              <li key={`${item.name}-${index}`}>
                {isLast || !item.to ? (
                  <span className={isLast ? "current" : undefined}>{item.name}</span>
                ) : (
                  <Link to={item.to}>{item.name}</Link>
                )}
                {!isLast && <span className="separator">{"›"}</span>}
              </li>
            );
          })}
        </ol>
      </Container>
    </>
  );
}
